import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { GVL, Vendor, VendorList } from '@iabtcf/core';

export const toggleAllStoreAndAccessDevice = action('adsPrefsOption_toggleAllStoreAndAccessDevice');

export const toggleAllowDevelopAndImproveProduct = action(
    'adsPrefsOption_toggleAllowDevelopAndImproveProduct'
);
export const toggleAllowPersonalisedAds = action('adsPrefsOption_toggleAllowPersonalisedAds');

export const toggleAllowPersonalisedAdsSelectBasicAd = action(
    'adsPrefsOption_toggleAllowPersonalisedAdsSelectBasicAd'
);
export const toggleAllowPersonalisedAdsApplyMarketResearch = action(
    'adsPrefsOption_toggleAllowPersonalisedAdsApplyMarketResearch'
);
export const toggleAllowPersonalisedAdsMeasureContentPerformance = action(
    'adsPrefsOption_toggleAllowPersonalisedAdsMeasureContentPerformance'
);
export const toggleAllowPersonalisedAdsSelectPersonalisedAds = action(
    'adsPrefsOption_toggleAllowPersonalisedAdsSelectPersonalisedAds'
);
export const toggleAllowPersonalisedAdsMeasureAdPerf = action(
    'adsPrefsOption_toggleAllowPersonalisedAdsMeasureAdPerf'
);
export const toggleAllowPersonalisedAdsSelectPersonalisedContent = action(
    'adsPrefsOption_toggleAllowPersonalisedAdsSelectPersonalisedContent'
);
export const toggleAllowPersonalisedAdsCreatePersonalisedContentProfile = action(
    'adsPrefsOption_toggleAllowPersonalisedAdsCreatePersonalisedContentProfile'
);
export const toggleAllowPersonalisedAdsCreatePersonalisedAdsProfile = action(
    'adsPrefsOption_toggleAllowPersonalisedAdsCreatePersonalisedAdsProfile'
);
export const toggleAllowPreciseGeoDataAndIdentifyDevice = action(
    'adsPrefsOption_toggleAllowPreciseGeoDataAndIdentifyDevice'
);
export const toggleAllowPreciseGeoDataAndIdentifyDeviceScanDevice = action(
    'adsPrefsOption_toggleAllowPreciseGeoDataAndIdentifyDeviceScanDevice'
);
export const toggleAllowPreciseGeoDataAndIdentifyDeviceGeoData = action(
    'adsPrefsOption_toggleAllowPreciseGeoDataAndIdentifyDeviceGeoData'
);

export const enableAllFeaturesVendorsOption = action(
    'adsPerfsOption_enableAllFeaturesVendorOption'
);

export const disableAllFeaturesVendorsOption = action(
    'adsPerfsOption_disableAllFeaturesVendorsOption',
    (vendorList: VendorList) => ({
        vendorList: vendorList,
    })
);

export const toggleVendorOption = action(
    'adsPerfsOption_toggleVendorOption',
    (vendorId: number, vendorList: VendorList) => ({
        vendorId: vendorId,
        vendorList: vendorList,
    })
);

export const toggleLegitimateInterestPurposesOption = action(
    'adsPerfsOption_toggleLegitimateInterestPurposesOption'
);

export const toggleFirstPartyCookieOption = action('adsPerfsOption_toggleFirstPartyCookieOption');

export const enableAllVendorsOption = action('adsPerfsOption_enableAllVendorOption');

export const disableAllVendorsOption = action(
    'adsPerfsOption_disableAllVendorsOption',
    (vendorList: VendorList) => ({
        vendorList: vendorList,
    })
);

export const retrieveGdprAdsV3VendorList = action('adsPrefsOption_retrieveGdprAdsV3VendorList');

export const setVendorList = action('adsPrefsOption_setVendorList', (vendorList: GVL) => ({
    vendorList: vendorList,
}));

export const setShownVendor = action('adsPrefsOption_setShownVendor', (vendor: Vendor) => ({
    vendor: vendor,
}));

export const loadGdprAdsV3Option = action('loadGdprAdsV3Option', () =>
    addDatapointConfig({ name: 'LoadGdprAdsV3Option' })
);

export const saveGdprAdsV3Option = action('saveGdprAdsV3Option', () =>
    addDatapointConfig({ name: 'SaveGdprAdsV3Option' })
);

export const saveEmailAdsSelectOptions = action('saveEmailAdsSelectOptions', () =>
    addDatapointConfig({ name: 'SaveEmailAdsSelectOptions' })
);

export const setEmailAdsSelectOptions = action(
    'adsPrefsOption_setEmailAdsSelectOptions',
    (optInBit: number) => ({
        optInBit: optInBit,
    })
);
